export enum PermissionInputType {
  Boolean = 'boolean',
  BooleanWithInheritance = 'boolean-with-inheritance',
  Filter = 'filter',
  Preset = 'preset',
}
